'use strict';

module.exports = document.createElement('div').style;



//////////////////
// WEBPACK FOOTER
// ./~/domkit/builtinStyle.js
// module id = 742
// module chunks = 0